import request from '@/utils/request';

// 获取枚举值列表
export function getEnumList(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/enum/list',
			method: 'get',
			params,
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取枚举值列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}

// 获取枚举值列表
export function getEnumAll() {
	return new Promise((resolve, reject) => {
		request({
			url: '/api/dict/all',
			method: 'get',
		})
			.then(response => {
				const res = response.data;
				if (res.code == 0) {
					resolve(res.data);
				} else {
					reject(new Error(res.msg || '获取枚举值列表失败'));
				}
			})
			.catch(error => {
				reject(error);
			});
	});
}
